import { useQueryHelper } from '@anytag/shared-hooks';
import { useTiktokSpecialPostQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export interface TemplateProps {
  className?: string;
}

export const Template = ({ className }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPostId } = usePostModalContext();
  const { data, loading } = useTiktokSpecialPostQuery({
    skip: !selectedPostId,
    fetchPolicy: 'cache-and-network',
    variables: { pk: Number(selectedPostId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const post = data?.tiktokSpecialPost;

  return (
    <PostModal.DetailsTemplate
      loading={loading}
      className={className}
      data={{
        socialMedia: 'TIKTOK',
        caption: post?.caption,
        postUrl: post?.postUrl,
        postDate: post?.postedDate,
        images: post?.images || [],
        info: {
          id: post?.influencer.id,
          name: post?.influencer.name,
          avatar: post?.influencer.avatar,
          followers: post?.influencer.followersCount
        },
        statistics: {
          likes: post?.likes,
          views: post?.views,
          shares: post?.shares,
          comments: post?.comments
        }
      }}
    />
  );
};
